import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

export const TextInput = styled(InputBase)(({ theme, width, error }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 8,
    position: "relative",
    backgroundColor: "white",
    border: error ? "1px solid red" : "1px solid #b3b9c9",
    fontSize: 14,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    color: "#777E90",
  },
}));
